import { render, staticRenderFns } from "./cModalAddTurn.vue?vue&type=template&id=70295855"
import script from "./cModalAddTurn.vue?vue&type=script&lang=js"
export * from "./cModalAddTurn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports